import type { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

export interface FavoriteItemProps extends PropsWithChildren {
  onAction: (isFavorite: boolean) => void;
  isFavorite: boolean;
  disabled?: boolean;
}

export const FavoriteItem = ({ onAction, isFavorite, children, disabled }: FavoriteItemProps) => {
  function favoriteAction() {
    onAction(!isFavorite);
  }

  return (
    <button
      type="button"
      aria-pressed={!!isFavorite}
      disabled={disabled}
      className={twMerge(
        'streaming-entry-bg h-28 w-full max-w-full rounded-lg border-gray-500 border-t-4 transition-colors duration-200 hover:border-gray-200 sm:max-w-56',
        isFavorite && 'border-primary hover:border-secondary',
      )}
      onClick={favoriteAction}
    >
      {children}
    </button>
  );
};
